import moment from 'moment';

export const MAX_AI_CALENDAR_CLEAR_RANGE_DAYS = 366;

const monthsBack = 3;
const monthsForward = 8;

export interface IAiCalendarClearRange {
	startDate: Date;
	endDate: Date;
}

export function getAiCalendarClearRange(now: Date = new Date()): IAiCalendarClearRange {
	return {
		startDate: moment(now).subtract(monthsBack, 'months').startOf('month').toDate(),
		endDate: moment(now).add(monthsForward, 'months').endOf('month').toDate(),
	};
}
